import { DatePickerInput, Icon, Button, Modal, Breadcrumb } from "pepsico-ds";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./extension_reactivation.css";
import arReactivateService from "../../services/arReactivateService";
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from "react-i18next";

const ExtensionRequest = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [userData, setUserData] = useState(null);
    const [isDateError, setIsDateError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [requestData, setRequestData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [previousDate, setPreviousDate] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [userGpId, setUserGpId] = useState(null);
    const { t, i18n } = useTranslation();
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));

    const navigate = useNavigate();

    const onClickCancel = () => {
        navigate(-1);
    }
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        const data = JSON.parse(localStorage.getItem("okta-token-storage"));
        if (data?.accessToken?.claims?.gpid) {
            setUserGpId(data?.accessToken?.claims?.gpid);
        }
        fetchUserData();

        return () => window.removeEventListener('resize', handleResize);
    }, [userGpId]);

    const fetchUserData = async () => {
        setLoading(true);
        setError(null);
        try {
            if (!userGpId) {
                setError(t('nonArExtension.gpid_missing_error'));
                setLoading(false);
                return;
            }
            const userId = { "gpid": userGpId };
            const response = await arReactivateService.getReactivatedUser(userId);
            if (response.data && Object.keys(response.data.mapOfRevalidationReactivateResponse).length > 0) {
                const key = Object.keys(response.data.mapOfRevalidationReactivateResponse)[0];
                const userDataResp = response.data.mapOfRevalidationReactivateResponse[key];
                const pepEffectiveDateFormatUpdate = new Date(userDataResp.pepEffectiveDate);
                userDataResp.pepEffectiveDate = `${(pepEffectiveDateFormatUpdate.getMonth() + 1).toString().padStart(2,'0')}/${pepEffectiveDateFormatUpdate.getDate().toString().padStart(2,'0')}/${pepEffectiveDateFormatUpdate.getFullYear()}`;
                setUserData(userDataResp);
                // const previousDate = response.data.mapOfRevalidationReactivateResponse[key].pepAppAAEnabledDate;
                const date = new Date();
                const formatted = new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit"
                }).format(date);
                setPreviousDate(formatted);
                const newDate = addDaysToDate(formatted);
                setSelectedDate(newDate);

            } else {
                setError(t('nonArExtension.error_no_data_for_gpid',{gpid: userId['gpid'] }))
            }
        } catch (err) {
            setError(err.message || t('nonArExtension.error_api_message'));
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        if (!selectedDate || !previousDate) return;
        const newDate = new Date(selectedDate);
        const prevDate = new Date(previousDate);
        const maxAllowedDate = new Date(prevDate);
        maxAllowedDate.setDate(prevDate.getDate() + 90);
        const newUTC = Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate());
        const maxUTC = Date.UTC(maxAllowedDate.getFullYear(), maxAllowedDate.getMonth(), maxAllowedDate.getDate());
        const prevUTC = Date.UTC(prevDate.getFullYear(), prevDate.getMonth(), prevDate.getDate());

        if (newUTC > maxUTC) {
            toast.error(t('nonArExtension.error_date_range_max', { date: prevDate.toLocaleDateString() }));
            setIsDateError(true);
            setSelectedDate(null);
        } else if (newUTC < prevUTC) {
            toast.error(t('nonArExtension.error_date_range_min', { date: prevDate.toLocaleDateString() }));
            setIsDateError(true);
            setSelectedDate(null);
        } else {
            setIsDateError(false);
        }

    }, [selectedDate]);

    function addDaysToDate(prevDate) {
        let oldDate = new Date(prevDate);
        let newDate = new Date(oldDate);
        newDate.setDate(oldDate.getDate() + 90);
        return newDate;
    }

    const onViewRequest = () => {
        // if(requestData?.requestId){
        //     let statePayload = { navigateFrom: "extension_request", requestId: requestData?.requestId};
        //     navigate("/myidmPortal", { state: statePayload });
        // }else{
        //     navigate("/myidmPortal", { state: { navigateFrom: "extension_request"} });
        // }
        navigate("/audit-requests")
    }

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className="reactivation-modal"
                    onCloseModal={closeModal}
                    closeOnOutsideClick = {false}
                    notificationsProps={{
                        secondaryActionLabel: (
                            <>
                                <Icon
                                    alt="alt value"
                                    icon={copyButtonText == t('nonArExtension.copied') ? "check" : "content_copy"}
                                    size="medium"
                                    style={{ marginRight: '6px', display: 'unset' }}
                                />

                                {copyButtonText}
                            </>
                        ),
                        secondaryActionOnClick: onClickCopynumber,
                        text: `${requestData?.requestId}`,
                        title: t('nonArExtension.request_number_title'),
                        type: 'info'
                    }}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={false}
                    showCloseButton={true}
                    style={{}}
                    text={<>
                    
                        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
                        <p style={{fontSize:'14px'}} className="modal-para-text mb-2">{t('RequestNewAccessForSelf.ticket_number_text')}: {requestData?.requestId}. {t('RequestNewAccessForSelf.save_number')} 
                        </p>
                        </div>
                    </>}
                    title={t('nonArExtension.self_extension_confirmation_title')}
                    type="fluid"
                    viewPort={`${isMobile ? "mobile" : "desktop"}`}
                >
                    <div><p style={{fontSize:'14px'}} className="modal-para-text mb-2">{t('RequestNewAccessForSelf.view_all_requests')}</p></div>
                    <div className="confirm-modal-btn">
                        <Button
                            className=""
                            size="medium"
                            style={{}}
                            text={t('nonArExtension.back')}
                            variant="tertiary"
                            onClick={closeModal}
                        />
                        <Button
                            className=""
                            size="medium"
                            style={{}}
                            text={t('homePage.view_request')}
                            variant="primary"
                            onClick={onViewRequest}
                        />
                    </div>
                </Modal>
            </div>
        )
    }

    const onClickSubmit = async () => {
        //    setShowModal(true);
        //    return;
        setIsSubmitting(true);
        const dateObj = new Date(selectedDate);
        const formatted = dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
        const data = {
            gpid: userData?.uid?.trim(),
            newReactivateDate: formatted
        }
        try {
            const response = await arReactivateService.updateReactivatedUser(data);
            if (response.status == 200) {
                if (response.data.status == 'Failed') {
                    toast.error(response.data.errorMessage);
                    setIsSubmitting(false);
                    return;
                }
                console.log('response', response);
                setRequestData(response.data);
                setIsSubmitting(false);
                setShowModal(true);
            } else {
                toast.error(t('nonArExtension.error_api'));
                setIsSubmitting(false);
                return;
            }

        } catch (error) {
            toast.error(t('nonArExtension.error_api'));
            setIsSubmitting(false);
        }
    }

    const closeModal = () => {
        setShowModal(false);
        setSelectedDate(null);
    }
    const onClickCopynumber = () => {
        if (requestData?.requestId) {
            navigator.clipboard.writeText(requestData.requestId.toString()).then(() => {
                setCopyButtonText(t('nonArExtension.copied'));
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }
    };

    const backToDashboard = () => {
        return (
            <>
                <div className="dashboard-btn" onClick={() => onClickCancel()}><Icon
                    alt="alt value"
                    icon="arrow_back"
                    size="medium"
                    style={{ marginRight: '8px' }}
                />{t('nonArExtension.back_to_dashboard')}</div>
            </>
        )
    }

    const capitalizeEveryFirstLetter =((str)=> {
        if (!str) return '';
        const strArr = str?.split?.(" ");
        return strArr?.map?.((str)=> str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())?.join?.(" ");
    });

    return (
        <>
            {(loading) && (<div>{t('nonArExtension.regular_loading')}</div>)}
            {(!loading && userData && isMobile) && backToDashboard()}
            {(userData) && (
                <>
                    <div style={{maxWidth: 'calc(100vw - 15%)', margin: 'auto'}} className="mb-2">
                        <Breadcrumb
                            homeIcon={{
                                icon: "home",
                                onClick:()=>{
                                navigate("/home")
                                }
                            }}
                            breadcrumbs={[
                                {
                                    label: t('nonArExtension.home')
                                },
                                {
                                    label: t('nonArExtension.myidm'),
                                    href: '/myidmPortal'
                                },
                                {
                                    label: t('myIdmPortal.non_employee_extension_for_self'),
                                    onClick: function oFe() { }
                                }
                            ]}
                            className=""
                            style={{}}
                        />
                        <div className="header-text-1 mt-2 mb-3">{t("nonArExtension.extension_request_for_self")}</div>
                    </div>
                    <div className="request-extension-container pb-0">
                        <div className="main-header">{t("nonArExtension.non_employee_extension")}</div>
                        <div className="secondary-header">{t("nonArExtension.request_for_self")}</div>
                        <div className="request-detail">
                            <div className="request-detail-container">
                                <div className="extenstion-icon">
                                    <Icon
                                        alt="Date Range"
                                        icon="date_range"
                                        size="small"
                                        style={{alignItems:'center'}}
                                    />
                                </div>
                                <div className="request-profile-title">{t('nonArExtension.provide_new_expiration')}</div>
                                <div className="request-profile-container">
                                    <DatePickerInput
                                        className="self-date-picker"
                                        endYear={2030}
                                        feedbackType="info"
                                        format="mm/dd/yyyy"
                                        helperText="Type or select new date (mm/dd/yyyy)"
                                        inputSize="medium"
                                        label={t('updateProfile.expirationDate')}
                                        placeholder={t('nonArExtension.expiration_date')}
                                        required
                                        menuPosition="top-left"
                                        error={isDateError}
                                        selected={selectedDate}
                                        setSelected={setSelectedDate}
                                        startYear={1950}
                                        style={{ width: `${isMobile ? "100%" : "63%"}`, textAlign: "center" }}
                                    />
                                </div>
                            </div>
                            <div className="request-detail-container">
                                <div className="extenstion-icon">
                                    <Icon
                                        alt="Person"
                                        icon="person"
                                        size="small"
                                        style={{alignItems:'center'}}
                                    />
                                </div>
                                <div className="request-profile-title">{t('updateProfile.associateInfo')}</div>
                                <div className="request-profile-container">
                                    <RequestInfoRow label={t('nonArExtension.first_name')} value={userData.pepDisplayedFirstName} />
                                    <RequestInfoRow label={t('nonArExtension.middle_name')} value="" />
                                    <RequestInfoRow label={t('nonArExtension.last_name')} value={userData.pepDisplayedLastName} />
                                </div>
                            </div>
                            <div className="request-detail-container">
                                <div className="extenstion-icon">
                                    <Icon
                                        alt="Domain"
                                        icon="domain"
                                        size="small"
                                        style={{alignItems:'center'}}
                                    />
                                </div>
                                <div className="request-profile-title">{t('updateProfile.jobInfo')}</div>
                                <div className="request-profile-container">
                                    <RequestInfoRow label={capitalizeEveryFirstLetter(t('nonArExtension.maintenance_type'))} value={t('nonArExtension.reactivate')} />
                                    <RequestInfoRow label={t('nonArExtension.manager')} value={userData.pepReportingManager} />
                                    <RequestInfoRow label={t('nonArExtension.self_start_date')} value={userData.pepEffectiveDate} />
                                </div>
                            </div>

                        </div>
                        <div className="extension-save-container" style={{ marginTop: '20px' }}>
                            <div className="extension-edit-status">
                                {/* <span className="extension-edit-mode-text">{t('nonArExtension.edit_mode')}</span>
                                <span style={{ fontSize: 14, color: "#616161" }}>
                                    {`${selectedDate ? `1 ${t('nonArExtension.change_made')}`
                                        : `0 ${t('nonArExtension.change_made')}`}`}
                                </span> */}
                            </div>
                            <div className="extension-edit-actions">
                                {(isMobile) ? (<>
                                    <Button
                                        className=""
                                        size="medium"
                                        style={{}}
                                        text={isSubmitting ? t('nonArExtension.submitting') : t('nonArExtension.submit')}
                                        variant="primary"
                                        disabled={isSubmitting || !selectedDate}
                                        onClick={onClickSubmit}
                                    />
                                    <button className="extension-cancel-button" onClick={onClickCancel} >
                                    {t('nonArExtension.cancel')}
                                    </button>
                                </>) : (
                                    <>
                                        <button className="extension-cancel-button" style={{fontSize: "16px"}} onClick={onClickCancel} >
                                            <Icon
                                                alt="alt value"
                                                icon="close"
                                                size="large"
                                                style={{ marginRight: '8px' }}
                                            />
                                            {t('nonArExtension.cancel')}
                                        </button>
                                        <Button
                                            className=""
                                            size="large"
                                            style={{}}
                                            text={isSubmitting ? t('nonArExtension.submitting') : t('nonArExtension.submit')}
                                            variant="primary"
                                            disabled={isSubmitting || !selectedDate}
                                            onClick={onClickSubmit}
                                        />
                                    </>
                                )}

                            </div>
                        </div>
                        <ToastContainer
                            position="bottom-center"
                            autoClose={5000}
                            hideProgressBar={false}
                            closeOnClick
                            pauseOnHover
                            draggable
                        />
                        {showModal && renderConfirmModal()}
                    </div>
                </>
            )}
            {(error) && (
                <div className="error-container">
                    <h4>{error}</h4>
                </div>
            )}
        </>
    )
};

const RequestInfoRow = ({ label, value }) => (
    <div className="request-profile-info">
        <span className="request-profile-label">{label}</span>
        <span className="request-profile-value">{value}</span>
    </div>
);

export default ExtensionRequest;
